import EntityStore from '#/unified-rfqs/store/entity';
import { Drfq } from '../entities/drfq/domain';

const MAX_CLOSED_DRFQS = 50;
export class DrfqHistoryStore extends EntityStore<Drfq> {
  constructor() {
    const sortComparer = (drfqA: Drfq, drfqB: Drfq) =>
      drfqB.last_updated_at.getTime() - drfqA.last_updated_at.getTime();

    super({ sortComparer });
  }

  setClosedDrfq(drfq: Drfq) {
    this.setOne(drfq); // Add the new drfq

    const drfqs = this.selectAll();

    if (drfqs.length > MAX_CLOSED_DRFQS) {
      const drfqsToRemove = drfqs.slice(MAX_CLOSED_DRFQS);

      for (const oldDrfq of drfqsToRemove) {
        this.removeOne(oldDrfq.id, { permanent: true });
      }
    }
  }
}
